<script setup>
// Galeria inicial: modelos prontos em dois modos + começar em branco.
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import API from 'dashboard/api/marketingEmailTemplates';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['create']);
const { t } = useI18n();
const dialog = ref(null);
const presets = ref([]);
const mode = ref('newsletter');
const busy = ref(false);

const COLORS = {
  relacionamento: '#1f93ff',
  vendas: '#00897b',
  agenda: '#4285f4',
  pos_venda: '#ffba18',
  prospeccao: '#00897b',
};
const visible = computed(() =>
  presets.value.filter(p => p.mode === mode.value)
);

const open = () => dialog.value?.open();
defineExpose({ open });

const pick = async preset => {
  busy.value = true;
  try {
    const { data } = preset
      ? await API.createFromPreset(preset.key)
      : await API.create({
          marketing_email_template: {
            mode: mode.value,
            name: t('EMAIL_TEMPLATES.GALLERY.BLANK_NAME'),
          },
        });
    dialog.value?.close();
    emit('create', data);
  } finally {
    busy.value = false;
  }
};

onMounted(async () => {
  const { data } = await API.gallery();
  presets.value = data;
});
</script>

<template>
  <Dialog
    ref="dialog"
    :title="t('EMAIL_TEMPLATES.GALLERY.TITLE')"
    :show-confirm-button="false"
    :show-cancel-button="false"
    width="3xl"
    overflow-y-auto
  >
    <div class="flex items-center gap-1 rounded-lg bg-n-solid-2 p-1 self-start">
      <button
        v-for="m in ['newsletter', 'personal']"
        :key="m"
        type="button"
        class="rounded-md px-3 py-1 text-xs font-medium"
        :class="
          mode === m ? 'bg-n-solid-1 text-n-slate-12 shadow' : 'text-n-slate-11'
        "
        @click="mode = m"
      >
        {{ t(`EMAIL_TEMPLATES.BUILDER.MODE.${m}`) }}
      </button>
    </div>
    <p class="text-xs text-n-slate-11">
      {{ t(`EMAIL_TEMPLATES.GALLERY.${mode.toUpperCase()}_HINT`) }}
    </p>
    <div class="grid grid-cols-2 gap-3 md:grid-cols-3">
      <button
        v-for="p in visible"
        :key="p.key"
        type="button"
        :disabled="busy"
        class="flex flex-col gap-2 rounded-xl border border-n-weak bg-n-solid-1 p-3 text-left hover:border-n-brand disabled:opacity-50"
        @click="pick(p)"
      >
        <span
          class="h-16 w-full rounded-lg"
          :style="{
            background: `linear-gradient(135deg, ${COLORS[p.category] || '#94a3b8'}, ${COLORS[p.category] || '#94a3b8'}55)`,
          }"
        />
        <span class="text-sm font-semibold text-n-slate-12">{{ p.name }}</span>
        <span class="text-xs leading-snug text-n-slate-11">{{
          p.description
        }}</span>
      </button>
      <button
        type="button"
        :disabled="busy"
        class="flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-n-weak p-3 text-sm text-n-slate-11 hover:border-n-brand hover:text-n-brand disabled:opacity-50"
        @click="pick(null)"
      >
        <span class="i-lucide-plus text-xl" />
        {{ t('EMAIL_TEMPLATES.GALLERY.BLANK') }}
      </button>
    </div>
  </Dialog>
</template>
